import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import {useRoute} from "vue-router";

import {nextTick, onMounted, reactive, UnwrapRef, watch} from "vue";
import { searchClinic } from "@/api/clinic";
import { searchDentistTeam } from "@/api/dentist_team";
import { debounce } from 'lodash-es';
import {getOrderInfo} from "@/api/order";
import {getRelatedInfoByRelatedType} from "@/api/leads";
interface Options {
    clinics: any[],
    dentists: any[]
}

interface Item {
    clinicId: number | string,
    dentistId: number | string,
    dentistName: string,
    clinicName: string,
    loading: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'selectClinicAndDentist',
  props: {
    orderId: {
        type: String,
        default: ""
    },
},
  emits: ['selectChange'],
  setup(__props, { emit: emits }) {

const props = __props;

const route = useRoute();


watch(
    () => props.orderId, async () => {
        await nextTick(()=>{
            if(props.orderId){
                getOrderDetail(props.orderId);
            }else{
                let relatedType = route.query.relatedType;
                let relatedId = route.query.relatedId;
                getRelatedInfoByRelatedType({relatedType:relatedType,relatedId:relatedId}).then((res:any)=>{
                    orderInfo.createDate = "";
                    orderInfo.relatedType = res.relatedType;
                    orderInfo.relatedName = res.relatedName;
                    orderInfo.typeStr = "";
                })
            }
        })
    },
    {
        immediate: true,
        deep: true,
    }
);
// interface OrderInfo{
//     typeStr: string,
//     createDate: string,
//     relatedName:string,
//     relatedType:number|undefined,
// }
const orderInfo = reactive({
    typeStr: "",
    createDate: "",
    relatedName:"",
    relatedType:0,
});
const state = reactive({
    data: [],
    value: [],
    fetching: false,
});

let item: UnwrapRef<Item> = reactive({
    dentistId: '',
    clinicId: '',
    dentistName: '',
    clinicName: '',
    loading: false
});

let options: UnwrapRef<Options> = reactive({
    clinics: [],
    dentists: []
});
let lastClinicId = 0;
const onSearchClinic = debounce((keyword: string) => {
    lastClinicId += 1;
    const fetchId = lastClinicId;
    state.fetching = true;
    options.clinics = []
    searchClinic({
        page: {
            pageSize: 100,
            currPage: 1,
        },
        keyword: keyword,
    }).then((res: any) => {
        if (fetchId !== lastClinicId) {
            // for fetch callback order
            return;
        }
        if (res.data) {
            res.data.forEach((r: any) => {
                options.clinics.push({
                    value: r.id,
                    label: r.shortName,
                });
            });
            state.fetching = false;
        }
    });
}, 300)
let lastFetchId = 0;
const onSearchDentistTeam = debounce(value => {
    console.log('fetching user', value);
    lastFetchId += 1;
    const fetchId = lastFetchId;
    state.fetching = true;
    options.dentists = []
    searchDentistTeam({
        page: {
            pageSize: 1000,
            currPage: 1,
        },
        keyword: value
    }).then((res: any) => {
        console.log("keyword:", res.data)
        if (fetchId !== lastFetchId) {
            // for fetch callback order
            return;
        }
        if (res.data) {
            res.data.forEach((r: any) => {
                if (null != r.principal)
                    options.dentists.push({
                        value: r.principal.id,
                        label: r.name,
                    });
                state.fetching = false;
            });
        }
    });
}, 300);
const selectedDentist = (value: string,options: any)=>{
    console.log(options)
    if(value){
        let res = {
            id: options.value,
            type: 4,
            name: options.label
        }
        console.log(res,"开始回传")
        emits("selectChange",res)
    }
}

const selectedClinic = (value: string,options: any)=>{
    console.log(options)
    if(value){
        let res = {
            id: options.value,
            type: 5,
            name: options.label
        }
        console.log(res,"开始回传")
        emits("selectChange",res)
    }
}
const getOrderDetail = (orderId: string)=>{
    getOrderInfo(orderId).then((res: any)=>{
        console.log(res);
        orderInfo.createDate = res.creationDate;
        orderInfo.relatedType = res.relatedType;
        orderInfo.relatedName = res.relatedName;
        orderInfo.typeStr = res.typeStr;
    })
}
onMounted(() => {
    onSearchDentistTeam('')
    onSearchClinic('')
})


return (_ctx: any,_cache: any) => {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, { gutter: 20 }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              title: "当前已选订单信息",
              style: {"height":"200px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions, {
                  size: "default",
                  column: 2
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_descriptions_item, { label: "订单类型" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(orderInfo.typeStr), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "创建时间" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(orderInfo.createDate), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "患者" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(orderInfo.relatedName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "患者类型" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(orderInfo.relatedType == 0 ?"线索":"病人"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_card, {
              title: "请选择医生和诊所信息",
              style: {"height":"200px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "医生" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          style: {"width":"200px"},
                          value: _unref(item).dentistId,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(item).dentistId) = $event)),
                          "show-search": "",
                          placeholder: "请输入查询关键写",
                          "filter-option": false,
                          "not-found-content": state.fetching ? undefined : null,
                          options: _unref(options).dentists,
                          onSearch: _unref(onSearchDentistTeam),
                          "default-active-first-option": false,
                          "show-arrow": false,
                          onSelect: selectedDentist
                        }, _createSlots({ _: 2 }, [
                          (state.fetching)
                            ? {
                                name: "notFoundContent",
                                fn: _withCtx(() => [
                                  _createVNode(_component_a_spin, { size: "small" })
                                ]),
                                key: "0"
                              }
                            : undefined
                        ]), 1032, ["value", "not-found-content", "options", "onSearch"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_form_item, { label: "诊所" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          style: {"width":"200px"},
                          placeholder: "请输入查询关键写",
                          value: _unref(item).clinicId,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(item).clinicId) = $event)),
                          options: _unref(options).clinics,
                          onSearch: _unref(onSearchClinic),
                          "filter-option": false,
                          "show-search": "",
                          "not-found-content": state.fetching ? undefined : null,
                          "default-active-first-option": false,
                          "show-arrow": false,
                          onSelect: selectedClinic
                        }, null, 8, ["value", "options", "onSearch", "not-found-content"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})